import { cancelTournamentRest } from '@/services/tournaments/tournaments-service';

import { cancelTournamentRestLobby } from '@/services/tournaments/tournaments-service';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { TournamentInfoDto } from '@repo/common-types';

const useCancelTournament = (
  tournamentId: string,
  tournamentUrl: string,
  { onSuccess }: { onSuccess?: () => void } = {},
) => {
  const queryClient = useQueryClient();
  const { mutateAsync: cancelTournament } = useMutation({
    mutationFn: async () => {
      if (tournamentUrl) {
        try {
          const result = await cancelTournamentRest(tournamentUrl);
          return result;
        } catch (error) {
          console.warn('Tournament server cancellation failed, falling back to lobby server:', error);
          // Fall through to lobby server
        }
      }
      const result = await cancelTournamentRestLobby(tournamentId);
      return result;
    },
    onSuccess: (updatedTournament: TournamentInfoDto) => {
      queryClient.invalidateQueries({ queryKey: ['tournament', tournamentId] });
      queryClient.invalidateQueries({ queryKey: ['tournaments', 'list'] });
      onSuccess?.();
    },
  });

  return { cancelTournament };
};

export default useCancelTournament;
